import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-up-bar',
  templateUrl: './up-bar.component.html',
  styleUrls: ['./up-bar.component.sass'],
})
export class UpBarComponent implements OnInit {
  @Input() menu: any;

  constructor() {
  }

  ngOnInit(): void {}
}
